import React from "react";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { Box } from "../Box/MainBox/MainBox";
import { MainText } from "../MainText";

interface Props {
  leftLabel: string;
  rightLabel: string;
  sliderWidth: number;
}

const SliderLabels = ({ sliderWidth = 500, leftLabel, rightLabel }: Props) => {
  return (
    <Box
      width={sliderWidth}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <MainText
        variant={isWebDesktop ? "l4-medium" : "l3-medium"}
        color="neutral.600"
      >
        {leftLabel}
      </MainText>
      <MainText
        variant={isWebDesktop ? "l3-semibold" : "l3-bold"}
        color="brand.500"
      >
        {rightLabel}
      </MainText>
    </Box>
  );
};

export default SliderLabels;
